import * as Yup from 'yup';
import { Formik } from 'formik';
import React from 'react';
import { ModalComponent } from 'components/layout/modals/ModalComponent';
import { FormField } from 'components/layout/form-fields/FormField';
import { jobApplicationHistoryStore } from './JobApplicationHistoryStore';

const ValidationSchema = Yup.object().shape({
	description: Yup.string().label('Description')
});

export class JobApplicationHistoryEdit extends ModalComponent {
	getInitialValues() {
		return {
			description: this.props.history.description || ''
		};
	}

	render() {
		return (
			<Formik
				initialValues={this.getInitialValues()}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.update(values);
				}}>
				{formikBag =>
					this.renderModalContainer(formikBag, 'JobApplicationHistoryEdit')
				}
			</Formik>
		);
	}

	renderForm(formikBag) {
		return (
			<div className="columns">
				<div className="column is-full">
					<FormField
						className="has-text-left"
						label="Description"
						field="description"
						type="textarea"
						placeholder="Description"
						maxlength={2500}
					/>
				</div>
			</div>
		);
	}

	async update(values) {
		jobApplicationHistoryStore
			.updateHistory(this.props.jobApplicationId, this.props.history.id, {
				history: {
					description: values.description
				}
			})
			.then(result => {
				this.resultNotification(result, 'history', 'Update');
			});
	}
}
